import React from 'react';
import { StyledLoadingSpinner } from './styles';

export const LoadingSpinner = () => {
  return <StyledLoadingSpinner />;
};
